// extracted by mini-css-extract-plugin
export default {"logo_img":"Logo_logo_img__m+pof"};